import { Grid } from "@mui/material";
import "../../../styles/trangchu.scss";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useNavigate } from "react-router-dom";

const loaiGiayPhepMoiTruongList = [
  {
    maMuc: "01",
    tenMuc: "Giấy xác nhận hoàn thành công trình bảo vệ môi trường"
  },
  { maMuc: "02", tenMuc: "Giấy phép xử lý chất thải nguy hại" },
  { maMuc: "03", tenMuc: "Sổ đăng ký chủ nguồn thải chất thải nguy hại" },
  { maMuc: "04", tenMuc: "Giấy phép xả khí thải" },
  { maMuc: "05", tenMuc: "Giấy phép xả nước thải vào công trình thủy lợi" },
  {
    maMuc: "05",
    tenMuc:
      "Giấy xác nhận đủ điều kiện về bảo vệ môi trường trong nhập khẩu phế liệu làm nguyên liệu sản xuất"
  },
  { maMuc: "07", tenMuc: "Giấy phép khai thác, sử dụng nước dưới đất" },
  { maMuc: "08", tenMuc: "Giấy phép môi trường" },
  { maMuc: "09", tenMuc: "Đăng ký môi trường" },
  { maMuc: "10", tenMuc: "Giấy phép khai thác khoáng sản" },
  { maMuc: "11", tenMuc: "Giấy phép khai thác và sử dụng nước mặt" }
];
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#f1f1f163",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary
}));
export default function ThongKeGP({ dataThongKe }) {
  let navigate = useNavigate();

  const [data, setData] = useState([]);

  const ChuyenTrangGP = maloai => {
    if (maloai === loaiGiayPhepMoiTruongList[0].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[1].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[2].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[3].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[4].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[5].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[6].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[7].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[8].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[9].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[10].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[11].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}`);
    }
  };
  const ChuyenTrangGPHL = (maloai, trangthai) => {
    if (maloai === loaiGiayPhepMoiTruongList[0].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[1].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[2].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[3].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[4].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[5].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[6].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[7].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[8].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[9].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[10].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    } else if (maloai === loaiGiayPhepMoiTruongList[11].maMuc) {
      navigate(`/giayphepmoitruong?maloai=${maloai}&trangthai=${trangthai}`);
    }
  };
  useEffect(() => {
    if (dataThongKe) {
      setData([
        {
          title: loaiGiayPhepMoiTruongList[0]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai
                ?.Giayxacnhanhoanthanhcongtrinhbaovemoitruong
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Giayxacnhanhoanthanhcongtrinhbaovemoitruong
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Giayxacnhanhoanthanhcongtrinhbaovemoitruong
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai
                ?.Giayxacnhanhoanthanhcongtrinhbaovemoitruong
            : 0,
          maloai: loaiGiayPhepMoiTruongList[0]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[1]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepxulychatthainguyhai
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai?.Giayphepxulychatthainguyhai
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai?.Giayphepxulychatthainguyhai
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepxulychatthainguyhai
            : 0,
          maloai: loaiGiayPhepMoiTruongList[1]?.maMuc
        },

        {
          title: loaiGiayPhepMoiTruongList[2]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Sodangkychunguonthaichatthainguyhai
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Sodangkychunguonthaichatthainguyhai
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Sodangkychunguonthaichatthainguyhai
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai
                ?.Sodangkychunguonthaichatthainguyhai
            : 0,
          maloai: loaiGiayPhepMoiTruongList[2]?.maMuc
        },

        {
          title: loaiGiayPhepMoiTruongList[3]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepxakhithai
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai?.Giayphepxakhithai
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai?.Giayphepxakhithai
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepxakhithai
            : 0,
          maloai: loaiGiayPhepMoiTruongList[3]?.maMuc
        },
        // {
        //     title: loaiGiayPhepMoiTruongList[4]?.tenMuc,
        //     value: dataThongKe ? dataThongKe?.giayPhepTheoLoai?.Giayphepxanuocthaivaonguonnuoccongtrinhthuyloi : 0,
        //     value_conhan: dataThongKe ? dataThongKe?.giayPhepConHanTheoLoai?.Giayphepxanuocthaivaonguonnuoc : 0,
        //     value_hethan: dataThongKe ? dataThongKe?.giayPhepHetHanTheoLoai?.Giayphepxanuocthaivaonguonnuoc : 0,
        //     value_kxd: dataThongKe ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepxanuocthaivaonguonnuoc : 0,
        //     maloai: loaiGiayPhepMoiTruongList[4]?.maMuc,
        // },
        {
          title: loaiGiayPhepMoiTruongList[4]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai
                ?.Giayphepxanuocthaivaonguonnuoccongtrinhthuyloi
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Giayphepxanuocthaivaonguonnuoccongtrinhthuyloi
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Giayphepxanuocthaivaonguonnuoccongtrinhthuyloi
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai
                ?.Giayphepxanuocthaivaonguonnuoccongtrinhthuyloi
            : 0,
          maloai: loaiGiayPhepMoiTruongList[4]?.maMuc
        },

        {
          title: loaiGiayPhepMoiTruongList[5]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai
                ?.Giayxacnhandudieukienvebaovemoitruongtrongnhapkhauphelieulamnguyenlieusanxuat
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Giayxacnhandudieukienvebaovemoitruongtrongnhapkhauphelieulamnguyenlieusanxuat
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Giayxacnhandudieukienvebaovemoitruongtrongnhapkhauphelieulamnguyenlieusanxuat
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai
                ?.Giayxacnhandudieukienvebaovemoitruongtrongnhapkhauphelieulamnguyenlieusanxuat
            : 0,
          maloai: loaiGiayPhepMoiTruongList[5]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[6]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepkhaithacsudungnuocduoidat
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Giayphepkhaithacsudungnuocduoidat
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Giayphepkhaithacsudungnuocduoidat
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai
                ?.Giayphepkhaithacsudungnuocduoidat
            : 0,
          maloai: loaiGiayPhepMoiTruongList[6]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[7]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepmoitruong
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai?.Giayphepmoitruong
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai?.Giayphepmoitruong
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepmoitruong
            : 0,
          maloai: loaiGiayPhepMoiTruongList[7]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[8]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Dangkymoitruong
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai?.Dangkymoitruong
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai?.Dangkymoitruong
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Dangkymoitruong
            : 0,
          maloai: loaiGiayPhepMoiTruongList[8]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[9]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepkhaithackhoangsan
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai?.Giayphepkhaithackhoangsan
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai?.Giayphepkhaithackhoangsan
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepkhaithackhoangsan
            : 0,
          maloai: loaiGiayPhepMoiTruongList[9]?.maMuc
        },
        {
          title: loaiGiayPhepMoiTruongList[10]?.tenMuc,
          value: dataThongKe
            ? dataThongKe?.giayPhepTheoLoai?.Giayphepkhaithacvasudungnuocmat
            : 0,
          value_conhan: dataThongKe
            ? dataThongKe?.giayPhepConHanTheoLoai
                ?.Giayphepkhaithacvasudungnuocmat
            : 0,
          value_hethan: dataThongKe
            ? dataThongKe?.giayPhepHetHanTheoLoai
                ?.Giayphepkhaithacvasudungnuocmat
            : 0,
          value_kxd: dataThongKe
            ? dataThongKe?.giayPhepKXDTheoLoai?.Giayphepkhaithacvasudungnuocmat
            : 0,
          maloai: loaiGiayPhepMoiTruongList[10]?.maMuc
        }
      ]);
    }
  }, [dataThongKe]);
  return (
    <div container className="thongke-main-gp ">
      <Scrollbars
        // autoHide
        renderThumbVertical={() => (
          <div
            style={{
              backgroundColor: "#a5a5a57d",
              marginTop: 2,
              borderRadius: 5,
              opacity: 0.4,
              overflowX: "hidden"
            }}
          />
        )}
        style={{ height: "100%" }}
        renderThumbHorizontal={() => <div></div>}
      >
        <div
          onClick={() => navigate("/giayphepmoitruong")}
          style={{
            cursor: "pointer",
            paddingBottom: 10,
            fontSize: 18,
            fontWeight: 700,
            fontStyle: "normal"
          }}
        >{`TỔNG SỐ GIẤY PHÉP: ${dataThongKe?.giayPhep || 0}`}</div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {data.map((record, index) => (
              <Grid item xs={12} sm={12} md={12} key={index}>
                <div className="thongke-item">
                  <Item style={{ boxShadow: "none", padding: 15 }}>
                    <div className="thongke-component-gp-hieuluc">
                      <div
                        style={{ width: 35 }}
                        onClick={() => ChuyenTrangGP(record?.maloai)}
                        className="thongke-number-gp"
                      >
                        {record?.value}
                      </div>
                      <div className="thongke-title-hieuluc">
                        {record.title}
                      </div>
                    </div>

                    <div className="thongke-component-gp">
                      <div className="thongke-component-gp">
                        <div className="thongke-contaier-hieuluc">
                          <div
                            onClick={() =>
                              ChuyenTrangGPHL(record?.maloai, "conHan")
                            }
                            style={{ backgroundColor: "#8fcb6e" }}
                            className="thongkehieuluc"
                          >
                            {record?.value_conhan}
                          </div>
                        </div>
                        <div className="thongke-title">Còn hạn</div>
                      </div>
                      <div className="thongke-component-gp">
                        <div className="thongke-contaier-hieuluc">
                          <div
                            onClick={() =>
                              ChuyenTrangGPHL(record?.maloai, "hetHan")
                            }
                            style={{ backgroundColor: "#ff5252" }}
                            className="thongkehieuluc"
                          >
                            {record?.value_hethan}
                          </div>
                        </div>
                        <div className="thongke-title">Hết hạn</div>
                      </div>
                      <div className="thongke-component-gp">
                        <div className="thongke-contaier-hieuluc">
                          <div
                            onClick={() =>
                              ChuyenTrangGPHL(record?.maloai, "khongXacDinh")
                            }
                            style={{ backgroundColor: "#a7a7a7" }}
                            className="thongkehieuluc"
                          >
                            {record?.value_kxd}
                          </div>
                        </div>
                        <div className="thongke-title">Không xác định</div>
                      </div>
                    </div>
                  </Item>
                </div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Scrollbars>
    </div>
  );
}
